import {
  JobSupport3fdjh0rbee4be as JobSupport,
  get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1 as get_COMPLETING_WAITING_CHILDREN,
} from './JobSupport.mjs';
import {
  Key_instancepi2bbb0csu5f as Key_instance,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from './Debug.mjs';
import {
  CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally,
  toState1lqvgl5d0bogr as toState,
} from './CompletionState.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from './CoroutineExceptionHandler.mjs';
import { get_coroutineName3a0vy840b4l1i as get_coroutineName } from './CoroutineContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractCoroutineClass;
function AbstractCoroutine() {
  if (AbstractCoroutineClass === VOID) {
    class $ extends JobSupport() {
      constructor(parentContext, initParentJob, active) {
        super(active);
        if (initParentJob) {
          this.initParentJob_jbhsg3_k$(parentContext.get_y2st91_k$(Key_instance));
        }
        this.context_1 = parentContext.plus_s13ygv_k$(this);
      }
      get_context_h02k06_k$() {
        return this.context_1;
      }
      get_coroutineContext_115oqo_k$() {
        return this.context_1;
      }
      get_isActive_quafmh_k$() {
        return super.get_isActive_quafmh_k$();
      }
      onCompleted_whnx9v_k$(value) {
      }
      onCancelled_gb68wi_k$(cause, handled) {
      }
      cancellationExceptionMessage_a64063_k$() {
        return get_classSimpleName(this) + ' was cancelled';
      }
      onCompletionInternal_38s8uv_k$(state) {
        if (state instanceof CompletedExceptionally()) {
          this.onCancelled_gb68wi_k$(state.cause_1, state.get_handled_cq14k3_k$());
        } else {
          this.onCompleted_whnx9v_k$(state);
        }
      }
      resumeWith_rk9gbt_k$(result) {
        var state = this.makeCompletingOnce_m8ggg9_k$(toState(result));
        if (state === get_COMPLETING_WAITING_CHILDREN())
          return Unit_instance;
        this.afterResume_ugh2hm_k$(state);
      }
      afterResume_ugh2hm_k$(state) {
        return this.afterCompletion_2p0irt_k$(state);
      }
      handleOnCompletionException_l1g6ri_k$(exception) {
        handleCoroutineException(this.context_1, exception);
      }
      nameString_4rfuxd_k$() {
        var tmp0_elvis_lhs = get_coroutineName(this.context_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return super.nameString_4rfuxd_k$();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var coroutineName = tmp;
        return '"' + coroutineName + '":' + super.nameString_4rfuxd_k$();
      }
      start_50fwcj_k$(start, receiver, block) {
        start.invoke_neaz0o_k$(block, receiver, this);
      }
    }
    initMetadataForClass($, 'AbstractCoroutine', VOID, VOID, [Job(), Continuation()], [0]);
    AbstractCoroutineClass = $;
  }
  return AbstractCoroutineClass;
}
//region block: exports
export {
  AbstractCoroutine as AbstractCoroutine2jzyhqo91sb0o,
};
//endregion

//# sourceMappingURL=AbstractCoroutine.mjs.map
